/**
 * Global close-readiness banner (เรื่อง 10) — persistent strip on every admin
 * page when the current period has cycle-affecting issues. Hides at 0 (clean
 * screen). Counts only 🔴 affects-cycle items (no 🟡) to avoid alert fatigue.
 */
import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { useCloseReadiness } from '../hooks';

export function CloseBanner() {
  const period = new Date().toISOString().slice(0, 7);
  const { data } = useCloseReadiness(period);
  if (!data || data.affectsCycleCount === 0) return null;

  const hard = data.hardBlockCount > 0;
  const tone = hard
    ? 'bg-red-50 border-red-200 text-red-800 hover:bg-red-100'
    : 'bg-amber-50 border-amber-200 text-amber-800 hover:bg-amber-100';

  return (
    <Link
      to="/owner/cycle#close"
      className={`flex items-center gap-2 border-b px-4 lg:px-8 py-2 text-sm transition ${tone}`}
    >
      <AlertTriangle className={`w-4 h-4 shrink-0 ${hard ? 'text-red-500' : 'text-amber-500'}`} />
      <span className="flex-1">
        {hard ? (
          <>ปิดงวดไม่ได้ — มี <span className="font-semibold">{data.hardBlockCount}</span> รายการต้องแก้ก่อน (ลืมทำเงินเดือน/ฐานเงินเดือน)</>
        ) : (
          <>มี <span className="font-semibold">{data.affectsCycleCount}</span> เรื่องต้องเคลียร์ก่อนปิดรอบเงินเดือนงวดนี้</>
        )}
      </span>
      <span className="underline shrink-0">ดูความพร้อม</span>
    </Link>
  );
}
